import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { ref, onMounted, onBeforeUnmount } from 'vue';
import ModalDialog from '@/components/ModalDialog/ModalDialog.vue';
import { Field } from '@sitecore-jss/sitecore-jss/types/layout';


export default /*@__PURE__*/_defineComponent({
  __name: 'RichTextWithModal',
  props: {
    field: {},
    modalContentHtml: {}
  },
  setup(__props: any) {

const props = __props;

const showModal = ref(false);
const modalContent = ref('');
const richTextWithModalRef = ref<HTMLElement | null>(null);

const handleClick = (event: Event) => {
  const target = event.target as HTMLElement;
  const link = target.closest('.open-modal');
  if (link && link instanceof HTMLElement) {
    event.preventDefault();
    modalContent.value = props.modalContentHtml?.value; //link.dataset.modalContent || 'RACQ modal content';
    showModal.value = true;
  }
};

onMounted(() => {
  richTextWithModalRef.value?.addEventListener('click', handleClick);
});

onBeforeUnmount(() => {
  richTextWithModalRef.value?.removeEventListener('click', handleClick);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      ref_key: "richTextWithModalRef",
      ref: richTextWithModalRef,
      innerHTML: _ctx.field?.value
    }, null, 8, _hoisted_1),
    _createVNode(ModalDialog, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
      showXCloseButton: true,
      closeOnEsc: true,
      size: "tooltip"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { innerHTML: modalContent.value }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})